import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import copy from 'clipboard-copy';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addJsonLdArticle } from '@/actions/JsonLdActions';
import { ImageBase } from '@/components/ui/Image/ImageBase';
import { APP_BASE_URL } from '@/define/env';
import { notify } from '@/helpers/action';
import { getViewYmd } from '@/helpers/common';
import { propBool, propFunc, propId, propShape, PropTypesAuthToken, } from '@/helpers/custom-prop-types';
import ClockIcon from '../../Icon/Svg/ClockIcon';
import FavoriteColumnBox from '../Common/FavoriteColumnBox';
import ShareList from '../Common/ShareList';
import ColumnComponentHtml from './ColumnComponentHtml';
import ColumnComponentSkeleton from './ColumnComponentSkeleton';
import ProfileBox from './ProfileBox';
import ProfileBoxAdmin from './ProfileBoxAdmin';
const ColumnComponent = (props) => {
    var _a, _b;
    const { auth, column, hasFavorite, hasFollow, id, isGuestUser, isPreUser, isProUser, loadingFavorite, loadingFollow, onClickButton, onClickLimitRegistration, onCreateFavorite, onCreateFollow, onDeleteFavorite, onDeleteFollow, } = props;
    const dispatch = useDispatch();
    // JSON-LD 追加
    useEffect(() => {
        var _a, _b;
        if (!column)
            return;
        const authorName = column.professional
            ? `${column.professional.lastName} ${column.professional.firstName}`
            : 'PROFFIT（プロフィット）編集部';
        const jsonLd = {
            author: {
                '@type': 'Person',
                name: authorName,
            },
            datePublished: column.displayFromAt,
            headline: column.title,
            image: ((_b = (_a = column.thumbnailPicture) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.src)
                ? [column.thumbnailPicture.default.src]
                : [],
            mainEntityOfPage: `${APP_BASE_URL}/column/${column.weightLevel}/${column.urlCode}`,
        };
        dispatch(addJsonLdArticle(jsonLd));
    }, [column, dispatch]);
    // share関連
    const onClickClip = useCallback((e) => {
        const { value } = e.currentTarget;
        copy(value).then(() => {
            notify('リンクをコピーしました');
        });
    }, []);
    if (!column) {
        return _jsx(ColumnComponentSkeleton, {});
    }
    const { content, displayFromAt, isLimit, professional, shortUrl, summary, themes, thumbnailPicture, title, tocContent, urlCode, } = column;
    return (_jsxs("div", Object.assign({ className: 'column_article' }, { children: [_jsx("div", Object.assign({ className: 'thumbnail_box' }, { children: _jsx(ImageBase, { alt: title, objectPosition: 'cover', src: ((_a = thumbnailPicture === null || thumbnailPicture === void 0 ? void 0 : thumbnailPicture.default) === null || _a === void 0 ? void 0 : _a.src) || '', webpSrc: (_b = thumbnailPicture === null || thumbnailPicture === void 0 ? void 0 : thumbnailPicture.webp) === null || _b === void 0 ? void 0 : _b.src }) })), _jsx("h1", Object.assign({ className: 'column_title' }, { children: title })), _jsxs("div", Object.assign({ className: 'description_box' }, { children: [_jsxs("p", Object.assign({ className: 'date' }, { children: [_jsx(ClockIcon, {}), _jsx("span", { children: getViewYmd(displayFromAt) })] })), themes.length > 0 && (_jsx("ul", Object.assign({ className: 'themes' }, { children: themes.map((theme, index) => (_jsx("li", Object.assign({ className: `theme ${index === themes.length - 1 ? 'is_last' : ''}` }, { children: theme.name }), theme.id))) })))] })), _jsxs("div", Object.assign({ className: 'column_content_header' }, { children: [_jsx(ShareList, { onClickClip: onClickClip, shareUrl: shortUrl, suffix: 'Proffit', title: title }), !isProUser && (_jsx(FavoriteColumnBox, { hasFavorite: hasFavorite, loadingFavorite: loadingFavorite, onCreateFavorite: onCreateFavorite, onDeleteFavorite: onDeleteFavorite, value: urlCode }))] })), _jsx(ColumnComponentHtml, { auth: auth, content: content, id: id, isGuest: isGuestUser, isLimit: isLimit, isPre: isPreUser, onClickButton: onClickButton, onClickLimitRegistration: onClickLimitRegistration, summary: summary, title: title, tocContent: tocContent }, content), _jsxs("div", Object.assign({ className: 'column_content_footer' }, { children: [_jsx(ShareList, { onClickClip: onClickClip, shareUrl: shortUrl, suffix: 'Proffit', title: title }), !isProUser && (_jsx(FavoriteColumnBox, { hasFavorite: hasFavorite, loadingFavorite: loadingFavorite, onCreateFavorite: onCreateFavorite, onDeleteFavorite: onDeleteFavorite, value: urlCode }))] })), professional ? (_jsx(ProfileBox, { description: professional.description, firstName: professional.firstName, hasFollow: hasFollow, id: professional.id, isProUser: isProUser, lastName: professional.lastName, loadingFollow: loadingFollow, onCreateFollow: onCreateFollow, onDeleteFollow: onDeleteFollow, organizationName: professional.organizationName, photo: professional.photo, professional: professional })) : (_jsx(ProfileBoxAdmin, {}))] })));
};
ColumnComponent.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    column: propShape(),
    hasFavorite: propBool().isRequired,
    hasFollow: propBool().isRequired,
    id: propId(),
    isGuestUser: propBool().isRequired,
    isPreUser: propBool().isRequired,
    isProUser: propBool().isRequired,
    loadingFavorite: propBool().isRequired,
    loadingFollow: propBool().isRequired,
    onClickButton: propFunc().isRequired,
    onClickLimitRegistration: propFunc().isRequired,
    onCreateFavorite: propFunc().isRequired,
    onCreateFollow: propFunc().isRequired,
    onDeleteFavorite: propFunc().isRequired,
    onDeleteFollow: propFunc().isRequired,
};
ColumnComponent.defaultProps = {
    column: undefined,
    id: '',
};
export default ColumnComponent;
